import "./searchPage.css";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { apiGet } from "../../serverApi";
import Tablel, { type ColumnDef } from "../../components/table/Tablel";
import { getItemIconUrl } from "../../util/wowhead";
import { Link } from "react-router-dom";
import { LoadingIcon } from "../../components/LoadingIcon";
import SearchInput from "@/client/components/search_input/SearchInput";

const SearchPage = (): JSX.Element => {
    const params = useParams();
    const searchParam = params["term"];
    const navigate = useNavigate();
    const [serachResults, setSearchResults] = useState<ApiItemSearchResponse | undefined>();

    useEffect(() => {
        setSearchResults(undefined);
        if (!searchParam || searchParam.length < 3) return;
        const searchTimer = setTimeout(() => {
            apiGet<ApiItemSearchResponse>(`/api/search/item/${searchParam}/50`).then((res) => {
                if (res.error) {
                    alert(`Failed to get search results: ${res.error.message}`);
                    return;
                }
                setSearchResults(res.data);
            });
        }, 500);
        return () => clearTimeout(searchTimer);
    }, [searchParam]);

    const columDefs: ColumnDef<ApiItemEntry>[] = [
        {
            name: "Item",
            dataKey: "itemName",
            canSort: true,
            defaultSort: "desc",
            render: (rd) => (
                <Link className="searchPageResultLink" to={`/item/${rd.itemId}`}>
                    <img className="itemIcon searchPageResultIcon" src={getItemIconUrl(rd.iconName, "large")}></img>
                    <span className={`itemQuality${rd.qualityId}`}>{rd.itemName}</span>
                </Link>
            ),
        },
    ];

    return (
        <>
            <div className="searchPageInput">
                <SearchInput
                    initValue={searchParam}
                    onChange={(term) => {
                        navigate(`/search/${term}`);
                        return false;
                    }}
                />
            </div>
            <div className="searchPageResults">
                {serachResults ? (
                    serachResults.items.length > 0 ? (
                        <>
                            <Tablel
                                columnDefs={columDefs}
                                data={serachResults?.items ?? []}
                                sortCol="itemName"
                                sortDir="asc"
                                customCssClasses={{
                                    thead: "searchResultsTableThead",
                                    th: "searchResultsTableTh",
                                    tr: "searchResultsTableTr",
                                    td: "searchResultsTableTd",
                                }}
                            ></Tablel>
                            {serachResults?.haveMore ? (
                                <span className="searchTooManyResults">Too many results, not all results are shown!</span>
                            ) : null}
                        </>
                    ) : (
                        <span className="searchNoResults">No results for "{searchParam}"</span>
                    )
                ) : searchParam ? (
                    <LoadingIcon className="pageLoadIcon" />
                ) : null}
            </div>
        </>
    );
};

export default SearchPage;
